import React, { Component } from "react";
import { connect } from "dva";
import moment from "moment";
import { Tag, Divider, List, Button, Spin, Form } from "antd";
// eslint-disable-next-line import/no-extraneous-dependencies
import { router } from "umi";
import SelectUser from "nbugs-select-user-pc";
// import { stringify } from 'qs';
import Card from "nbugs-mobile-card";
import { GetQueryString, getComposeUrl } from "../../../../utils/common";
import Container from "../../../../components/Container";
import styles from "./index.less";

const { Item } = List;

const statusIcon = {
  0: "#C3C3C3",
  1: "#1785EC"
};
const statusText = {
  1: "进行中",
  2: "已结束"
};

@Form.create()
@connect(({ activityDetail, user }) => {
  return {
    ...activityDetail,
    currentUser: user.currentUser
  };
})
class ActivityDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpandScope: false, // 人员范围的展开与否
      isExpandSamePermission: false, // 相同权限人的展开与否
      attendList: [], // 人员范围的展开列表
      samePermissionList: [], // 相同权限人列表
      originScopeList: [], // 初始的活动范围列表
      originSameList: [] // 初始的相同权限人列表
    };
    this.id = GetQueryString("id");
  }

  componentDidMount() {
    // this.handleUnExpand();
    this.getDetail();
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: "activityDetail/reset"
    });
  }

  // 获取活动详情
  getDetail = () => {
    const { dispatch } = this.props;
    dispatch({
      type: "activityDetail/fetchDetail",
      params: {
        id: this.id
      }
      // callback: this.callback
    });
  };

  // 活动详情的回调
  // callback = () => {
  //   this.setOriginDetail();
  // };

  // 获取详情后打卡范围设置初始值
  setScopeOriginDetail = ({ selectResult }) => {
    const tempArr = [];
    const { all } = selectResult;
    const { depts, users } = all;
    depts.map(item1 => {
      if (item1.key === "tag") {
        tempArr.push(item1.tagName);
      } else {
        tempArr.push(item1.deptName);
      }
    });
    users.map(item2 => {
      tempArr.push(item2.userName);
    });
    if (tempArr.length > 10) {
      this.setState({
        originScopeList: tempArr,
        attendList: tempArr.slice(0, 10)
      });
    } else {
      this.setState({
        originScopeList: tempArr,
        attendList: tempArr
      });
    }
  };

  // 获取详情后相同权限人设置初始值
  setSameOriginDetail = ({ selectResult }) => {
    const tempArr = [];
    const { all } = selectResult;
    const { depts, users } = all;
    depts.map(item1 => {
      if (item1.key === "tag") {
        tempArr.push(item1.tagName);
      } else {
        tempArr.push(item1.deptName);
      }
    });
    users.map(item2 => {
      tempArr.push(item2.userName);
    });
    if (tempArr.length > 10) {
      this.setState({
        originSameList: tempArr,
        samePermissionList: tempArr.slice(0, 10)
      });
    } else {
      this.setState({
        originSameList: tempArr,
        samePermissionList: tempArr
      });
    }
  };

  // 展开人员范围
  handleExpandRecord = () => {
    const { originScopeList } = this.state;
    this.setState({
      attendList: originScopeList,
      isExpandScope: true
    });
  };

  // 收起人员范围
  handleUnExpandRecord = () => {
    const { originScopeList } = this.state;
    this.setState({
      attendList: originScopeList.slice(0, 10),
      isExpandScope: false
    });
  };

  // 展开相同权限人
  handleExpandSamePermission = () => {
    const { originSameList } = this.state;
    this.setState({
      samePermissionList: originSameList,
      isExpandSamePermission: true
    });
  };

  // 收起相同权限人
  handleUnExpandSamePermission = () => {
    const { originSameList } = this.state;
    this.setState({
      samePermissionList: originSameList.slice(0, 10),
      isExpandSamePermission: false
    });
  };

  // 底部按钮属性
  handleFooterProps = list => {
    const demFooter = list.map(item => (
      <Button type={item.type} onClick={item.click ? item.click : () => {}}>
        {item.title}
      </Button>
    ));
    return {
      states: true,
      demFooter: <>{demFooter}</>
    };
  };

  // 删除活动
  handleDelActivity = () => {
    const { dispatch } = this.props;
    dispatch({
      type: "activityDetail/fetchDelActivity",
      params: {
        id: this.id
      },
      callback: this.goToList
    });
  };

  // 编辑活动
  handleGoToEdit = () => {
    const url = `/interaction/activitySign/list/detail/create`;
    router.push(`${getComposeUrl(url)}?id=${this.id}`);
  };

  // 跳转列表
  goToList = () => {
    const url = "/interaction/activitySign/list";
    router.push(`${getComposeUrl(url)}`);
  };

  // 渲染状态标签
  renderStatusTag = () => {
    const { detail } = this.props;
    const { status } = detail;
    return (
      <Tag
        style={{
          background: "white",
          border: `1px solid ${statusIcon[status]}`,
          color: `${statusIcon[status]}`
        }}
      >
        {statusText[status]}
      </Tag>
    );
  };

  // 具有展开按钮的渲染(实际数据, 要展示的数据, 展开时的回调, 收起时的回调, 是否展开)
  renderExpandTag = (
    originlist,
    showlist,
    expandcallback,
    unexpandcallback,
    isExpand,
    length
  ) => {
    return (
      <>
        {showlist.map((item, index) =>
          index === 0 ? (
            <Tag style={{ marginLeft: 16, marginTop: 3 }}>{item}</Tag>
          ) : (
            <Tag style={{ marginTop: 3 }}>{item}</Tag>
          )
        )}
        <span style={{ marginLeft: showlist.length ? 8 : 16 }}>
          共{length}人
        </span>
        {originlist?.length > 10 &&
          (!isExpand ? (
            <span
              className="expand"
              style={{ color: "#1785EC", marginLeft: 8 }}
              onClick={expandcallback}
            >
              展开
            </span>
          ) : (
            <span
              className="unExpand"
              style={{ color: "#1785EC", marginLeft: 8 }}
              onClick={unexpandcallback}
            >
              收起
            </span>
          ))}
      </>
    );
  };

  indicatorsTag = value => {
    const data = [];
    return (
      <>
        {value.forEach(item => {
          if (item.selected) {
            data.push({ ...item });
          }
        })}
        {data.map((item, index) => {
          return index === 0 ? (
            <Tag style={{ marginLeft: 16, marginTop: 3 }}>{item.name}</Tag>
          ) : (
            <Tag style={{ marginTop: 3 }}>{item.name}</Tag>
          );
        })}
      </>
    );
  };

  // 底部按钮渲染
  renderFooterBtn = () => {
    const { detail, currentUser } = this.props;
    const { status, bureauEducationFlag } = detail;
    const { orgType } = currentUser || {};
    if (bureauEducationFlag === 1 && orgType === "school") {
      return {};
    }
    if (status === 1) {
      const list = [
        {
          type: "default",
          title: "删除",
          click: this.handleDelActivity
        },
        {
          type: "primary",
          title: "编辑",
          click: this.handleGoToEdit
        }
      ];
      return this.handleFooterProps(list);
    }
    if (status === 2) {
      const list = [
        {
          type: "primary",
          title: "删除",
          click: this.handleDelActivity
        }
      ];
      return this.handleFooterProps(list);
    }
  };

  render() {
    const {
      isExpandScope,
      attendList,
      samePermissionList,
      isExpandSamePermission,
      originScopeList,
      originSameList
    } = this.state;
    const { detail, spinProps } = this.props;
    const {
      name,
      publisher,
      endDate,
      scopeList,
      sameAuthorityList,
      content,
      createTime,
      scopeSelectId,
      authoritySelectId,
      hasIndex,
      indexList
    } = detail;
    const endTime = endDate ? moment(endDate).format("YYYY.MM.DD") : "";
    const sendTime = createTime ? moment(createTime).format("YYYY.MM.DD") : "";
    const containerProps = {
      breStates: true,
      version: 2,
      footerParams: this.renderFooterBtn(),
      defaultPadding: true,
      isSplitBar: true
    };
    const scopeSelectProps = {
      renderSelectBtn: false,
      appId: 40,
      appName: "活动打卡",
      getCheckedNodes: this.setScopeOriginDetail,
      selectSignature: scopeSelectId,
      renderSelectedList: false
    };
    const sameSelectProps = {
      renderSelectBtn: false,
      appId: 40,
      appName: "活动打卡",
      getCheckedNodes: this.setSameOriginDetail,
      selectSignature: authoritySelectId,
      renderSelectedList: false
    };
    return (
      <Container {...containerProps}>
        <div className={styles.root}>
          <Spin {...spinProps}>
            <div className="first_part">
              <div className="title">
                <div className="left">
                  <span className="verticalBar" />
                  <span>
                    {name}
                    {this.renderStatusTag()}
                  </span>
                </div>
              </div>
              <Divider />
              <div className="activityNews">
                <Item>
                  <span className="itemName">发布者</span>:
                  <span style={{ marginLeft: 16 }}>{publisher}</span>
                </Item>
                <Item>
                  <span className="itemName">发布时间</span>:
                  <span style={{ marginLeft: 16 }}>{sendTime}</span>
                </Item>
                <Item>
                  <span className="itemName">发布对象</span>:
                  {this.renderExpandTag(
                    originScopeList,
                    attendList,
                    this.handleExpandRecord,
                    this.handleUnExpandRecord,
                    isExpandScope,
                    scopeList?.length
                  )}
                </Item>
                {originSameList && originSameList.length > 0 && (
                  <Item>
                    <span className="itemName">相同权限人</span>:
                    {this.renderExpandTag(
                      originSameList,
                      samePermissionList,
                      this.handleExpandSamePermission,
                      this.handleUnExpandSamePermission,
                      isExpandSamePermission,
                      sameAuthorityList?.length
                    )}
                  </Item>
                )}
                {endTime && (
                  <Item>
                    <span className="itemName">截止时间</span>:
                    <span style={{ marginLeft: 16 }}>{endTime}</span>
                  </Item>
                )}
                {!!hasIndex && (
                  <Item>
                    <span className="itemName">统计指标</span>:
                    {this.indicatorsTag(indexList)}
                  </Item>
                )}
              </div>
            </div>
            <div className="second_part">
              <Divider orientation="left">详情</Divider>
              <div>
                {content && (
                  <Card maxHeight={160} wrapShowMode="normal">
                    <div dangerouslySetInnerHTML={{ __html: content }} />
                  </Card>
                )}
              </div>
            </div>
          </Spin>
          <SelectUser {...scopeSelectProps} />
          <SelectUser {...sameSelectProps} />
        </div>
      </Container>
    );
  }
}

export default ActivityDetail;
